<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear>
                <a-select-option value="1">审核成功</a-select-option>
                <a-select-option value="2">等待审核</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="场次">
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsq" changeOnSelect/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="送培场次">
              <a-cascader :show-search="{ sjsqSongPeiFilter }" :options="sjsqSongpeiOptions"
                          :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区"
                          v-model="queryParam.sjsqSongpei" changeOnSelect/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">

      <a-upload
          name="file"
          accept=".xlsx"
          action
          :before-upload="beforeUpload"
          style="margin-left: 8px;display: inline-block"
      >
        <a-button>
          上传名单
          <a-icon type="upload"/>
        </a-button>
<!--        <a-button @click="downloadTpl">-->
<!--          下载模板-->
<!--          <a-icon type="download" />-->
<!--        </a-button>-->
      </a-upload>

    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            <a-tag color="blue">{{ record.year }}年</a-tag>
           {{ record.province ? record.province +(record.city ? record.city: '') + (record.county ? record.county: ''): "管理端上传" }}
            <span style="color: #999">人数 {{ record.membercount }}</span>
            <br/>
            上传时间 {{ record.today|timeFormat }}
            <br/>
            <a-tag v-if="record.peixun_name">{{record.peixun_name}}</a-tag>
            <br/>
          </div>
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.status==1" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status==2" color="red">待审核</a-tag>
        <a-tag v-else-if="record.status==3">审核失败</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a @click="handleEdit(record)">查看</a>
          <a-divider type="vertical" v-if="record.cert_url"/>
          <a v-if="record.cert_url" @click="downloadCert(record)">下载证书</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="确定审核吗?" @confirm="handleShenhe(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">审核</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.status==1"/>
          <a v-if="record.status==1" @click="handlePrints(record)">批量打印</a>
          <a-divider type="vertical"/>
          <a v-if="record.xlssrc" @click="downloadXlsx(record)">下载表格文件</a>
          <a-divider v-if="record.xlssrc" type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="applyDelete(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>


    <a-modal
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="管理员备注"
              hasFeedback
          >
            <a-input  v-model="formData.admin_note"
                placeholder="请输入管理员备注"/>
          </a-form-item>

            <a-divider>人员信息</a-divider>

          <a-table :columns="subjectColumns" :data-source="formData.member_list" :pagination="false">
            <p slot="extra_field" slot-scope="record" style="margin: 0">
            </p>
            <p slot="name" slot-scope="text,record">
              {{ record.name }}
              <a-tag v-show="record.code">{{ record.code }}</a-tag>
              <br/>
              {{ record.num }}
            </p>
            <p slot="grade" slot-scope="text,record">
              {{ record.grade_name }}<br/>
              <span v-show="record.regist_date>0">注册日期{{ record.regist_date|timeFormat }}</span>
            </p>
            <template slot="action" slot-scope="text,record,index">
              <!-- <a href="javascript:;" @click="onEditUser(record)">编辑</a> -->
              <a href="javascript:;" v-show="record.cert_url" @click="downloadUserCert(record)">下载证书</a>
              <a-divider type="vertical"/>
            </template>
          </a-table>
        </a-form>


      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="orderVisible"
        @ok="handleOrderOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位"
                  hasFeedback
              >
                {{ orderFormData.danwei }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人"
                  hasFeedback
              >
                {{ orderFormData.ldname }}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="应付"
                  hasFeedback
              >
                <a-input v-model="orderFormData.pay_price" allowClear placeholder="应付金额"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线上实付"
                  hasFeedback
              >
                {{ orderFormData.payed_price }}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="线上支付时间"
                  hasFeedback
              >
                {{ orderFormData.pay_time_str }}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="支付状态"
                  hasFeedback
              >
                <a-radio-group v-model="orderFormData.status" button-style="solid">
                  <a-radio-button :value="1">
                    未支付
                  </a-radio-button>
                  <a-radio-button :value="2">
                    支付成功
                  </a-radio-button>
                </a-radio-group>

              </a-form-item>
            </a-col>
          </a-row>

          <a-col :md="48" :sm="24">
            <a-form-item
                :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                label="支付方式"
                hasFeedback
            >
              {{ orderFormData.pay_type_name }}
            </a-form-item>
          </a-col>
          </a-row>


          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="管理员备注"
                  hasFeedback
              >
                <a-textarea v-model="orderFormData.adminnote" placeholder="" auto-size/>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleOrderCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOrderOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        title="人员操作"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="userFormVisible"
        @ok="handleUserFormOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form3">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="姓名"
                  hasFeedback
              >
                <a-input v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                         placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="身份证"
                  hasFeedback
              >
                <a-input v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                         placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="性别"
                  hasFeedback
              >
                <a-input v-decorator="[
              'sex',
              {rules: [{ required: true, message: '请输入性别' }]}
            ]"
                         placeholder="请输入性别"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="手机"
                  hasFeedback
              >
                <a-input v-decorator="[
              'phone',
              {rules: [{ required: true, message: '请输入手机' }]}
            ]"
                         placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="服务套餐"
                  hasFeedback
              >

                <a-select
                    showSearch
                    optionFilterProp="title"
                    v-model="userFormData.service_id"
                    placeholder="选择服务套餐"
                    allowClear
                >
                  <a-select-option v-for="(option,index) in serviceTypeOptions" :value="option.id">{{ option.name }}
                  </a-select-option>

                </a-select>

              </a-form-item>
            </a-col>

          </a-row>


          <a-divider>申报信息</a-divider>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有裁判等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipandengjiwudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报裁判等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipanshenbaowudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有裁判等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipandengjijiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报裁判等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.caipanshenbaojiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有教练等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaoliandengjiwudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报教练等级（舞蹈）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaolianshenbaowudao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="已有教练等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaoliandengjijiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="申报教练等级（技巧）"
                  hasFeedback
              >
                <a-input
                    v-model="userFormData.jiaolianshenbaojiqiao"
                    placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


        </a-form>
      </a-spin>

      <template slot="footer">
        <a-button key="cancel" @click="handleUserFormCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserFormOk">保存</a-button>
      </template>
    </a-modal>
    <a-modal
        :maskClosable="false"
        :footer="null"
        title="批量生成"
        v-model="taskInfoShow"
    >
      <a-badge status="success" :text="'生成成功 '+(taskInfo.scount)"/>
      <a-divider type="vertical"/>
      <a-badge status="error" :text="'生成失败 '+(taskInfo.fcount)"/>
      <a-divider type="vertical"/>
      <a-badge status="processing" :text="'总数 '+(taskInfo.urls.length-1) "/>
      </p>
      <a-progress :percent="taskInfo.percent"/>
      </p>
      <div style="height: 300px; overflow:scroll;">
        <p v-for="(error,i) in taskInfo.urls" :key="i">{{ error.name }}</p> 
      </div>
    </a-modal>


    <a-modal
        :maskClosable="false"
        :footer="null"
        title="批量生成"
        v-model="taskInfoShow2"
    >
      <a-badge status="success" :text="'校验成功 '+(taskInfo2.scount)"/>
      <a-divider type="vertical"/>
      <a-badge status="error" :text="'校验失败 '+(taskInfo2.fcount)"/>
      <a-divider type="vertical"/>
      <a-badge status="processing" :text="'总数 '+(taskInfo2.members.length) "/>
      </p>
      <p v-show="taskInfo2.errors.length>0">存在以下错误，请修正后重新上传 </p>
      <div style="height: 300px; overflow:scroll;">
        <p v-for="error in taskInfo2.errors">{{ error }}</p>
        <p v-for="error in taskInfo2.errors">{{ error }}</p>
        <p v-for="error in taskInfo2.errors">{{ error }}</p>
      </div>
      <a-progress :percent="taskInfo2.percent"/>
      </p>
    </a-modal>

  </a-card>
</template>

<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import PicUploader from "@/components/PicUploader/";
import FileUploader from "@/components/FileUploader/";
import JiaolianPicker from "@/components/JiaolianPicker/";
import CaipanPicker from "@/components/CaipanPicker/";
import areaOptions from "@/utils/area";
import moment from "moment";
import qs from "qs";
import setting from "@/config/setting";
import XLSX from "xlsx";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

import {
  getApplyList,
  getShengShenheUrls,
  checkShengMemberOK,
  shengcpApply,
  getShengApplyDetail,
  getServiceTypeList,
  editShengApply,
  applyDelete,
  getApplyOrderDetail,
  editApplyOrder,
  getApplyUserDetail,
  editApplyUser,
  editShengCpManage,
  shengApplyDelete,
  shengCaipanPrint,
} from "@/api/caipan";
import { doUrlTask } from "@/api/utils";
import { sjsqOptions } from "@/api/huiyi";
import { sjsqOptions as sjsqSongpeiOptions } from "@/api/songpei";

export default {
  name: "KaojiApplyList",
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    CaipanPicker,
    JiaolianPicker,
  },
  data() {
    return {
      areaOptions,
      taskInfoShow: false,
      taskInfoShow2: false,
      visible: false,
      orderVisible: false,
      saveLoading: false,
      userFormVisible: false,
      jiaolianPickerShow: false,
      caipanPickerShow: false,
      sjsqOptions: [],
      sjsqSongpeiOptions: [],
      orderFormData: {},
      taskInfo: {
        urls: [],
        errors: [],
        currentIndex: 0,
        scount: 0,
        fcount: 0,
        percent: 0,
        doing: false,
      },

      taskInfo2: {
        members: [],
        errors: [],
        currentIndex: 0,
        scount: 0,
        fcount: 0,
        percent: 0,
        doing: false,
      },
      formData: {
        id: 0,
        danwei: "",
        areas: [],
        member_list: [],
        loglist: [],
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: "",
        sjsq: [],
        sjsqSongpei: [],
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "报名信息",
          dataIndex: "danwei",
          scopedSlots: { customRender: "danwei" },
        },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 300,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 表头
      subjectColumns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "姓名",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "电话",
          dataIndex: "phone",
        },
        {
          title: "微信",
          dataIndex: "weixin",
        },
        {
          title: "等级",
          dataIndex: "grade",
          scopedSlots: { customRender: "grade" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format("YYYY-MM-DD HH:mm:ss"),
            this.time_range_moment[1].format("YYYY-MM-DD HH:mm:ss"),
          ];
        } else {
          this.queryParam.time_range = [];
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getApplyList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: "",
        price: 0,
        note: "",
        count: 0,
      },
      serviceTypeOptions: [],
      userFormData: {
        id: 0,
        name: "",
        caipandengjiwudao: "",
        caipandengjijiqiao: "",
        jiaoliandengjiwudao: "",
        jiaoliandengjijiqiao: "",
        caipanshenbaowudao: "",
        caipanshenbaojiqiao: "",
        jiaolianshenbaowudao: "",
        jiaolianshenbaojiqiao: "",
      },
    };
  },
  computed: {},

  created() {},

  mounted() {
    let that = this;

    let query = this.$route.query;
    // 6, 276
    console.log(query);
    if (query.saiji) {
      this.queryParam.sjsq = [query.saiji, query.saiqu];
    }
    if (query.id) { 
      this.queryParam.keywords =query.id
    }
    that.getSjsqOptions();
    that.getSongpeiSjsqOptions();
  },
  methods: {
    moment,

    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then((res) => {
        that.sjsqOptions = res.data;
      });
    },
    getSongpeiSjsqOptions() {
      let that = this;
      sjsqSongpeiOptions({}).then((res) => {
        that.sjsqSongpeiOptions = res.data;
      });
    },
    handleCancel() {
      this.visible = false;
    },
    handleOrderCancel() {
      this.orderVisible = false;
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },

    handleEdit(record) {
      let self = this;
      this.visible = true;
      getShengApplyDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data });
          self.formData.id = record.id;
          console.log("handleEdit");
          if (res.data.area) {
            res.data.areas = [
              res.data.area.substring(0, 2) + "0000",
              res.data.area.substring(0, 4) + "00",
              res.data.area,
            ];
          } else {
            res.data.areas = [];
          }
          self.formData = { ...res.data };
        }, 200);
      });
      // console.log(this.mdl)
    },
    handleOrderEdit(record) {
      let self = this;
      getApplyOrderDetail({ baoming_id: record.id })
        .then((res) => {
          self.orderVisible = true;
          setTimeout(() => {
            self.orderFormData.id = record.id;
            console.log("handleEdit");

            self.orderFormData = { ...res.data };
          }, 200);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      self.visible = false;
      // return true;
      e.preventDefault();
      // if (self.formData.areas.length != 3) {
      //   self.$message.error('请选择完整地区');
      //   return;
      // }
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.formData);
          self.saveLoading = true;
          editShengCpManage({
            id: self.formData.id,
            admin_note: self.formData.admin_note,
            // ldname: self.formData.ldname,
            // weixin: self.formData.weixin,
            // email: self.formData.email,
            // phone: self.formData.phone,
            // fapiao_taitou: self.formData.fapiao_taitou,
            // fapiao_shuihao: self.formData.fapiao_shuihao,
            // fapiao_beizhu: self.formData.fapiao_beizhu,
            // fapiao_email: self.formData.fapiao_email,
            // fapiao_phone: self.formData.fapiao_phone,
            // memberstatus: self.formData.memberstatus,
            // area: self.formData.areas[self.formData.areas.length - 1],
            // address: self.formData.address,
          })
            .then((res) => {
              self.$message.success("修改成功");
              self.$refs.table.refresh(false);
              self.visible = false;
              self.saveLoading = false;
            })
            .catch((err) => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            });
        }
      });
    },
    // 增改 处理
    handleOrderOk(e) {
      let self = this;
      e.preventDefault();

      self.saveLoading = true;
      editApplyOrder({
        id: self.orderFormData.id,
        baoming_id: self.orderFormData.baoming_id,
        status: self.orderFormData.status,
        adminnote: self.orderFormData.adminnote,
        memberprice: self.orderFormData.memberprice,
        pay_price: self.orderFormData.pay_price,
      })
        .then((res) => {
          self.$message.success("修改成功");
          self.$refs.table.refresh(false);
          self.orderVisible = false;
          self.saveLoading = false;
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
          self.saveLoading = false;
        });
    },

    // 删
    applyDelete(record) {
      let self = this;
      shengApplyDelete({ id: record.id })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh();
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    // 删
    applyDeleteAll() {
      let self = this;
      applyDelete({ ids: self.selectedRowKeys, id: 0 })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh();
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },

    onEditUser(record) {
      let self = this;
      this.userFormVisible = true;
      getApplyUserDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form3.setFieldsValue({ ...res.data });
          self.userFormData.id = record.id;
          self.userFormData = { ...res.data };
        }, 200);
      });
      getServiceTypeList({ saiqu: self.formData.saiqu }).then((res) => {
        setTimeout(() => {
          self.serviceTypeOptions = res.data;
        }, 200);
      });
    },
    handleUserFormCancel() {
      this.userFormVisible = false;
    },

    handleUserFormOk(e) {
      let self = this;
      e.preventDefault();
      this.form3.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.userFormData);
          self.saveLoading = true;
          editApplyUser({
            id: self.userFormData.id,
            name: values.name,
            num: values.num,
            phone: values.phone,
            sex: values.sex,
            service_id: self.userFormData.service_id,
            caipandengjiwudao: self.userFormData.caipandengjiwudao,
            caipandengjijiqiao: self.userFormData.caipandengjijiqiao,
            jiaoliandengjiwudao: self.userFormData.jiaoliandengjiwudao,
            jiaoliandengjijiqiao: self.userFormData.jiaoliandengjijiqiao,
            caipanshenbaowudao: self.userFormData.caipanshenbaowudao,
            caipanshenbaojiqiao: self.userFormData.caipanshenbaojiqiao,
            jiaolianshenbaowudao: self.userFormData.jiaolianshenbaowudao,
            jiaolianshenbaojiqiao: self.userFormData.jiaolianshenbaojiqiao,
          })
            .then((res) => {
              self.$message.success("修改成功");
              self.userFormVisible = false;
              self.saveLoading = false;
            })
            .catch((err) => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            });
        }
      });
    },

    download(type) {
      console.log("this.queryParam");
      console.log(this.queryParam);
      if (
        typeof this.queryParam.sjsq == "undefined" ||
        this.queryParam.sjsq.length != 2
      ) {
        this.$message.error("请先选择赛区");
        return;
      }
      switch (type) {
        case 1:
          window.open(
            setting.apiBaseURL +
              "/adminapi/huiyi/applyDownload?saiqu=" +
              qs.stringify(this.queryParam)
          );
          break;
        case 2:
          window.open(
            setting.apiBaseURL +
              "/adminapi/huiyi/memberDownload?saiqu=" +
              qs.stringify(this.queryParam)
          );
          break;
        case 3:
          window.open(
            setting.apiBaseURL +
              "/adminapi/sai/rysfzDownload?saiqu=" +
              this.queryParam.sjsq[1]
          );
          break;
        case 4:
          window.open(
            setting.apiBaseURL +
              "/adminapi/sai/csrstjDownload?saiqu=" +
              this.queryParam.sjsq[1]
          );
          break;
        case 5:
          window.open(
            setting.apiBaseURL +
              "/adminapi/sai/zhixuceDownload?saiqu=" +
              this.queryParam.sjsq[1] +
              "&memberstatus=" +
              (this.queryParam.memberstatus || 0)
          );
          break;
        case 6:
          window.open(
            setting.apiBaseURL +
              "/adminapi/sai/caiwuDownload?saiqu=" +
              this.queryParam.sjsq[1]
          );
          break;
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    handlePrints(record) {
      let that = this;
      this.taskInfoShow = true;
      getShengApplyDetail({ id: record.id }).then((res) => {
        console.log(res);
        that.taskInfo = {
          urls: res.data.member_list,
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          doing: true,
        };
        that.doPrint(that.taskInfo);
      });
    },
    doPrint(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.urls.length) {
        taskInfo.doing = false;
        // that.taskInfoShow = false;
        that.$refs.table.refresh();
        return false;
      }
      shengCaipanPrint({
        id: taskInfo.urls[taskInfo.currentIndex].id,
      })
        .then((res) => {
          taskInfo.urls[taskInfo.currentIndex].name += "-打印成功";
          taskInfo.scount++;
          taskInfo.currentIndex++;
          console.log(taskInfo.currentIndex);
          if (taskInfo.currentIndex == taskInfo.urls.length) {
          }
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.urls.length) *
            100
          ).toFixed(1);
          that.doPrint(taskInfo);
        })
        .catch((err) => {
          taskInfo.urls[taskInfo.currentIndex].name =
            taskInfo.urls[taskInfo.currentIndex].name + "-" + err.data.msg;
          taskInfo.fcount++;
          taskInfo.currentIndex++;
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.urls.length) *
            100
          ).toFixed(1);

          that.doPrint(taskInfo);
        });
    },
    handleShenhe(record) {
      let that = this;
      this.taskInfoShow = true;
      getShengShenheUrls({
        id: record.id,
      })
        .then((res) => {
          that.taskInfo = {
            urls: res.data,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            doing: true,
          };
          that.doTask(that.taskInfo);
        })
        .catch((err) => {
          that.$message.error(err.data.msg);
        });
    },
    doTask(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.urls.length) {
        taskInfo.doing = false;
        that.taskInfoShow = false;
        that.$refs.table.refresh();
        return false;
      }
      doUrlTask({
        url: taskInfo.urls[taskInfo.currentIndex],
      })
        .then((res) => {
          taskInfo.scount++;
          taskInfo.currentIndex++;
          console.log(taskInfo.currentIndex);
          if (taskInfo.currentIndex == taskInfo.urls.length) {
          }
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.urls.length) *
            100
          ).toFixed(1);
          that.doTask(taskInfo);
        })
        .catch((err) => {
          taskInfo.fcount++;
          taskInfo.currentIndex++;
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.urls.length) *
            100
          ).toFixed(1);
          that.doTask(taskInfo);
        });
    },
    downloadCert(record) {
      window.open(setting.apiBaseURL + "" + record.cert_url);
    },
    downloadXlsx(record) {
      window.open(setting.apiBaseURL + "" + record.xlssrc);
    },

    downloadUserCert(record) {
      window.open(setting.apiBaseURL + "" + record.cert_url);
    },

    sjsqFilter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },
    sjsqSongPeiFilter(inputValue, path) {
      return path.some(
        (option) =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },

    downloadTpl() {
      window.open(
        "https://ccago.oss-cn-hangzhou.aliyuncs.com/template/裁判员证书申请表2021【仅限cca端上传】.xlsx"
      );
    },
    beforeUpload(file) {
      let that = this;
      let formdata = new FormData();
      console.log(file);
      formdata.append("upfile", file);
      formdata.append("action", "test");
      console.log("formdata", formdata);
      if (this.queryParam.sjsq.length != 2) {
        // that.$message.error('请先选择场次')
        // return false;
      }

      this.file2Xce(file).then((tabJson) => {
        // console.log('this.xlsxJson', tabJson);
        if (tabJson && tabJson.length > 0) {
          // this.xlsxJson = tabJson
          console.log("this.xlsxJson", tabJson);
          // if (typeof tabJson[0].sheet[0].__EMPTY_12 == 'undefined' || tabJson[0].sheet[0].__EMPTY_12 != "版本2021001") {
          //   that.$message.error('文件版本不正确');
          //   return;
          // }

          let userList = [];
          tabJson[0].sheet.map((item, index) => {
            if (index >= 0 && item["身份证号"]) {
              let wudaoGrade = item["批复裁判等级"]
                ? item["批复裁判等级"].substr(
                    0,
                    item["批复裁判等级"].length - 1
                  )
                : "";
              let jiqiaoGrade = item["批复教练等级"]
                ? item["批复教练等级"].substr(
                    0,
                    item["批复教练等级"].length - 1
                  )
                : "";

              userList.push({
                name: item["姓名"],
                num: item["身份证号"],
                phone: item["联系电话"] || "",
                email: item["邮箱"] || "",
                weixin: item["微信"] || "",
                province: item["省"] || "",
                city: item["市"] || "",
                county: item["区县"] || "",
                namekey: item["省市代码"] || "",
                danwei: item["单位全称"] || "",
                sex: item["性别"] || "",
                wudaoGrade: wudaoGrade,
                // jiqiaoGrade: jiqiaoGrade,
              });
            }
          });

          // console.log('userList', userList);
          // return ;

          that.taskInfo2 = {
            members: userList,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            errors: [],
            doing: true,
          };
          that.taskInfoShow2 = true;
          that.doTask2(that.taskInfo2);
        }
      });

      /*
      expressImport(formdata)
        .then(res => {
          that.$message.success('上传成功')
          that.$refs.table.refresh(true)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })*/
      return false; // false就是不自动上传，我后来试了发现都一样，都不会自动上传
    },

    file2Xce(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary",
          });
          const result = [];
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName]),
            });
          });
          resolve(result);
        };
        // reader.readAsBinaryString(file.raw)
        reader.readAsBinaryString(file); // 传统input方法
      });
    },

    doTask2(taskInfo) {
      let that = this;
      if (taskInfo.currentIndex >= taskInfo.members.length) {
        taskInfo.doing = false;
        //结束
        if (taskInfo.fcount == 0) {
          shengcpApply({
            list: JSON.stringify(taskInfo.members),
            peixun_id: that.queryParam.sjsq[1],
            peixun_songpei_id: that.queryParam.sjsqSongpei[1],
          }).then((res) => {
            that.taskInfoShow2 = false;
            that.$message.success("上传成功");
            that.$refs.table.refresh(true);
          });
        }
        return false;
      }
      if(!taskInfo.members[taskInfo.currentIndex].namekey){
            that.taskInfoShow2 = false;
            that.$message.error('管理端上传省市代码那列不能为空')
            return ;
      }
      checkShengMemberOK({
        name: taskInfo.members[taskInfo.currentIndex].name,
        num: taskInfo.members[taskInfo.currentIndex].num,
        wudaograde: taskInfo.members[taskInfo.currentIndex].wudaoGrade,
        jiqiaograde: taskInfo.members[taskInfo.currentIndex].jiqiaoGrade,
      })
        .then((res) => {
          if (res.data.length > 0) {
            taskInfo.fcount++;
            taskInfo.errors = taskInfo.errors.concat(res.data);
            taskInfo.currentIndex++;
          } else {
            taskInfo.scount++;
            taskInfo.currentIndex++;
            console.log(taskInfo.currentIndex);
            if (taskInfo.currentIndex == taskInfo.members.length) {
            }
          }
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.members.length) *
            100
          ).toFixed(1);
          that.doTask2(taskInfo);
        })
        .catch((err) => {
          taskInfo.fcount++;
          taskInfo.currentIndex++;
          taskInfo.percent = (
            (taskInfo.currentIndex / taskInfo.members.length) *
            100
          ).toFixed(1);
          that.doTask2(taskInfo);
        });
    },
  },
  filters: {},
  watch: {},
};
</script>
